export const globalCta = () => {
  // console.log('TESTING');
  $('.close-btn').click(function () {
    // alert('testing');
    $(this).addClass('closed').next('.btn-box').hide();
  });
};
